export const AUTH_VERSION = "v3-2026-06-01";

export const getUserToken = () => {
  return localStorage?.getItem("auth_token");
};

export const getUserRole = () => {
  return localStorage?.getItem("role");
};

export const getUserName = () => {
  return localStorage?.getItem("user_name");
};
